"use client";

import { cn } from "@/utils/cn";
import { useImageGallery } from "..";

interface GalleryImageCounterProps {
	className?: string;
	showImageName?: boolean;
}

export function GalleryImageCounter({ className, showImageName = true }: GalleryImageCounterProps) {
	const { currentIndex, images } = useImageGallery();

	const currentImage = images[currentIndex];

	if (images.length <= 1) return null;

	return (
		<div className={cn("absolute top-3 left-3 z-10 flex items-center h-6", className)}>
			<div className="bg-black/50 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-full">
				{currentIndex + 1} / {images.length}
				{showImageName && currentImage?.name && ` • ${currentImage.name}`}
			</div>
		</div>
	);
}
